module.exports = __webpack_public_path__ + "static/img/sg_role.d28485c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/sg_role.png
// module id = EkoT
// module chunks = 7